/**
 * Complete SEO information map for all categories
 * Reusable in multiple components and pages
 */
export const CATEGORY_SEO_MAP = {
  'antiestres': {
    slug: 'antiestres',
    name: 'Anti Estrés',
    title: 'Anti Estrés Promocionales Personalizados',
    h1: 'Productos Anti Estrés Personalizados',
    description: 'Pelotas anti estrés, squishies, fidget toys y juguetes promocionales para reducir el estrés. Personalización con logo corporativo en Colombia.',
    shortDescription: 'Juguetes y productos anti estrés personalizables',
    keywords: 'anti estrés personalizado, pelotas anti estrés con logo, fidget promocional, juguetes anti estrés corporativos',
    icon: '🧘',
    featured: true
  },
  
  'antimicrobianos': {
    slug: 'antimicrobianos',
    name: 'Antimicrobianos',
    title: 'Productos Antimicrobianos Promocionales',
    h1: 'Artículos Antimicrobianos con Logo',
    description: 'Artículos promocionales con tratamiento antimicrobiano. Llaveros, bolígrafos y productos de protección antibacterial personalizados.',
    shortDescription: 'Productos con protección antimicrobiana',
    keywords: 'productos antimicrobianos, promocionales antibacteriales, artículos protección antimicrobiana',
    icon: '🦠',
    featured: false
  },
  
  'articulos-reflectivos-y-de-precaucion': {
    slug: 'articulos-reflectivos-y-de-precaucion',
    name: 'Artículos Reflectivos y de Precaución',
    title: 'Artículos Reflectivos y de Precaución Promocionales',
    h1: 'Productos Reflectivos de Seguridad',
    description: 'Gorras reflectivas, chalecos de seguridad, bandas reflectivas, morrales y bolsas con elementos de alta visibilidad. Ideales para campañas de seguridad vial.',
    shortDescription: 'Elementos reflectivos para seguridad vial',
    keywords: 'articulos reflectivos promocionales, seguridad vial corporativa, chalecos reflectivos personalizados, gorras alta visibilidad',
    icon: '🦺',
    featured: true
  },
  
  // ── Slugs reales del API ────────────────────────────────
  'articulos-cuidado-personal-covid-19': { slug: 'articulos-cuidado-personal-covid-19', name: 'Cuidado Personal' },
  'articulos-de-cuidado-personal':       { slug: 'articulos-de-cuidado-personal',       name: 'Cuidado Personal' },
  'articulos-home-office-teletrabajo':   { slug: 'articulos-home-office-teletrabajo',   name: 'Home Office' },
  'automovil':                           { slug: 'automovil',                           name: 'Automóvil' },
  'bar-y-vino':                          { slug: 'bar-y-vino',                          name: 'Bar y Vino' },
  'bicicleta':                           { slug: 'bicicleta',                           name: 'Bicicleta' },
  'ecologia-ecopromo':                   { slug: 'ecologia-ecopromo',                   name: 'Ecología Ecopromo' },
  'juegos-y-entretenimiento':            { slug: 'juegos-y-entretenimiento',            name: 'Juegos y Entretenimiento' },
  'maletines-y-bolsos':                  { slug: 'maletines-y-bolsos',                  name: 'Maletines y Bolsos' },
  'medicos-y-farmaceuticos':             { slug: 'medicos-y-farmaceuticos',             name: 'Médicos y Farmacéuticos' },
  'mugs-botilitos-vasos-y-termos':       { slug: 'mugs-botilitos-vasos-y-termos',       name: 'Mugs y Termos' },
  'nuevos-productos-2025':               { slug: 'nuevos-productos-2025',               name: 'Nuevos Productos 2025' },
  'paraguas-e-impermeables':             { slug: 'paraguas-e-impermeables',             name: 'Paraguas e Impermeables' },
  'pharma-y-cuidado-personal':           { slug: 'pharma-y-cuidado-personal',           name: 'Pharma y Cuidado Personal' },
  'pla-acido-polilactico':               { slug: 'pla-acido-polilactico',               name: 'Plástico Poliláctico' },
  'sanitized':                           { slug: 'sanitized',                           name: 'Sanitizer' },
  // ────────────────────────────────────────────────────────

  'articulos-cuidado-personal': {
    slug: 'articulos-cuidado-personal',
    name: 'Cuidado Personal',
    title: 'Artículos de Cuidado Personal Promocionales',
    h1: 'Productos de Cuidado Personal con Logo',
    description: 'Kits de cuidado personal, espejos, cepillos, cortaúñas y accesorios de belleza personalizados para campañas promocionales.',
    shortDescription: 'Kits y accesorios de cuidado personal',
    keywords: 'cuidado personal promocional, kits belleza corporativos, espejos personalizados',
    icon: '💄',
    featured: false
  },
  
  'articulos-de-escritura': {
    slug: 'articulos-de-escritura',
    name: 'Escritura',
    title: 'Escritura Personalizados',
    h1: 'Bolígrafos y Plumas Promocionales',
    description: 'Bolígrafos metálicos, ecológicos, plumas ejecutivas, lápices y sets de escritura con grabado láser o impresión de logo.',
    shortDescription: 'Bolígrafos, plumas y sets de escritura',
    keywords: 'bolígrafos personalizados, plumas con logo, artículos escritura promocionales',
    icon: '✏️',
    featured: true
  },
  
  'bicicletas': {
    slug: 'bicicletas',
    name: 'Bicicletas',
    title: 'Accesorios para Bicicletas Promocionales',
    h1: 'Productos para Ciclismo Personalizados',
    description: 'Accesorios para ciclistas: luces LED, herramientas, porta botellas, cascos y productos personalizables para el ciclismo.',
    shortDescription: 'Accesorios para bicicletas y ciclismo',
    keywords: 'accesorios bicicleta promocionales, productos ciclismo corporativos, merchandising ciclista',
    icon: '🚴',
    featured: false
  },
  
  'calculadoras': {
    slug: 'calculadoras',
    name: 'Calculadoras',
    title: 'Calculadoras Personalizadas',
    h1: 'Calculadoras Promocionales con Logo',
    description: 'Calculadoras básicas, científicas y solares con impresión de logo. Regalos corporativos ideales para el sector educativo.',
    shortDescription: 'Calculadoras básicas y científicas',
    keywords: 'calculadoras personalizadas, calculadoras con logo, calculadoras promocionales',
    icon: '🧮',
    featured: false
  },
  
  // CONFECCIONES
  'confecciones': {
    slug: 'confecciones',
    name: 'Confecciones',
    title: 'Confecciones y Textiles Promocionales',
    h1: 'Ropa y Confecciones Personalizadas',
    description: 'Camisetas, polos, chaquetas, uniformes y prendas textiles con bordado o estampado de alta calidad.',
    shortDescription: 'Textiles y confecciones personalizadas',
    keywords: 'confecciones personalizadas, textiles promocionales, ropa corporativa, uniformes con logo',
    icon: '👕',
    featured: true
  },
  
  'deportes': {
    slug: 'deportes',
    name: 'Deportes',
    title: 'Artículos Deportivos Promocionales',
    h1: 'Productos Deportivos con Logo',
    description: 'Balones, bandas elásticas, accesorios fitness, botellas deportivas y equipamiento personalizado para eventos.',
    shortDescription: 'Artículos deportivos y fitness',
    keywords: 'artículos deportivos promocionales, productos fitness corporativos, merchandising deportivo',
    icon: '⚽',
    featured: false
  },
  
  'eco-nature': {
    slug: 'eco-nature',
    name: 'Eco Nature',
    title: 'Productos Ecológicos Eco Nature',
    h1: 'Línea Eco Nature - Promocionales Sostenibles',
    description: 'Línea ecológica certificada: bolsas reutilizables, artículos en bambú, materiales reciclados. Promociona tu marca cuidando el ambiente.',
    shortDescription: 'Productos ecológicos y sostenibles',
    keywords: 'productos ecológicos promocionales, eco friendly corporativo, merchandising sostenible',
    icon: '🌱',
    featured: true
  },
  
  'ecologia-ecoprommo': {
    slug: 'ecologia-ecoprommo',
    name: 'Ecología',
    title: 'Línea Ecológica Ecoprommo',
    h1: 'Productos Ecoprommo Personalizados',
    description: 'Productos ecológicos certificados Ecoprommo. Materiales biodegradables y reciclables con personalización.',
    shortDescription: 'Línea Ecoprommo biodegradable',
    keywords: 'ecoprommo productos ecológicos, promocionales biodegradables, merchandising verde',
    icon: '♻️',
    featured: true
  },
  
  'golf': {
    slug: 'golf',
    name: 'Golf',
    title: 'Artículos de Golf Promocionales',
    h1: 'Accesorios de Golf Personalizados',
    description: 'Paraguas de golf, tees, pelotas, marcadores y accesorios de golf personalizados para torneos y eventos corporativos.',
    shortDescription: 'Accesorios para golf',
    keywords: 'golf promocional, accesorios golf corporativo, regalos golf personalizados',
    icon: '⛳',
    featured: false
  },
  
  'gorras': {
    slug: 'gorras',
    name: 'Gorras',
    title: 'Gorras Personalizadas',
    h1: 'Gorras Promocionales con Logo',
    description: 'Gorras promocionales con bordado o estampado. Diferentes modelos: planas, trucker, deportivas. Todos los colores disponibles.',
    shortDescription: 'Gorras con bordado o estampado',
    keywords: 'gorras personalizadas, gorras con logo, cachuchas promocionales, gorras bordadas',
    icon: '🧢',
    featured: true
  },
  
  'herramientas': {
    slug: 'herramientas',
    name: 'Herramientas',
    title: 'Herramientas Promocionales',
    h1: 'Sets de Herramientas Personalizadas',
    description: 'Sets de herramientas, multitools, linternas LED, metros y herramientas personalizadas para regalos corporativos.',
    shortDescription: 'Herramientas y multitools',
    keywords: 'herramientas promocionales, multitools personalizadas, sets herramientas corporativas',
    icon: '🔧',
    featured: false
  },
  
  'hogar': {
    slug: 'hogar',
    name: 'Hogar',
    title: 'Artículos para el Hogar Promocionales',
    h1: 'Productos para el Hogar con Logo',
    description: 'Productos para el hogar personalizados: delantales, manteles, sets de cocina, organizadores con tu logo.',
    shortDescription: 'Artículos para el hogar',
    keywords: 'artículos hogar promocionales, productos casa personalizados, merchandising hogar',
    icon: '🏠',
    featured: false
  },
  
  // ILUMINACIÓN
  'iluminacion': {
    slug: 'iluminacion',
    name: 'Iluminación',
    title: 'Productos de Iluminación Promocionales',
    h1: 'Linternas y Lámparas Personalizadas',
    description: 'Linternas LED, lámparas, luces de emergencia y productos de iluminación personalizados con logo corporativo.',
    shortDescription: 'Linternas y productos de iluminación',
    keywords: 'iluminación promocional, linternas personalizadas, lámparas corporativas',
    icon: '💡',
    featured: false
  },
  
  'infantil': {
    slug: 'infantil',
    name: 'Infantil',
    title: 'Productos Infantiles Promocionales',
    h1: 'Artículos Infantiles Personalizados',
    description: 'Juguetes, mochilas escolares, loncheras, útiles escolares y productos infantiles personalizados.',
    shortDescription: 'Productos para niños',
    keywords: 'productos infantiles promocionales, juguetes personalizados, merchandising niños',
    icon: '🧸',
    featured: true
  },
  
  'juegos-entretenimiento': {
    slug: 'juegos-entretenimiento',
    name: 'Juegos y Entretenimiento',
    title: 'Juegos y Entretenimiento Promocionales',
    h1: 'Juegos Personalizados',
    description: 'Juegos de mesa, rompecabezas, cartas, dominó y productos de entretenimiento personalizados.',
    shortDescription: 'Juegos de mesa y entretenimiento',
    keywords: 'juegos promocionales, entretenimiento corporativo, juegos mesa personalizados',
    icon: '🎮',
    featured: false
  },
  
  'llaveros': {
    slug: 'llaveros',
    name: 'Llaveros',
    title: 'Llaveros Personalizados',
    h1: 'Llaveros Promocionales con Logo',
    description: 'Llaveros promocionales en acrílico, metal, cuero, PVC, madera. Diseños 2D y 3D con tu logo. Producción desde 100 unidades.',
    shortDescription: 'Llaveros en diversos materiales',
    keywords: 'llaveros personalizados, llaveros con logo, llaveros promocionales, llaveros corporativos',
    icon: '🔑',
    featured: true
  },
  
  'maletines-bolsos': {
    slug: 'maletines-bolsos',
    name: 'Maletines y Bolsos',
    title: 'Maletines y Bolsos Promocionales',
    h1: 'Maletines Ejecutivos Personalizados',
    description: 'Maletines ejecutivos, bolsos de viaje, portafolios, morrales y maletas personalizadas con bordado o estampado.',
    shortDescription: 'Maletines, bolsos y maletas',
    keywords: 'maletines personalizados, bolsos promocionales, maletas corporativas, portafolios con logo',
    icon: '💼',
    featured: false
  },
  
  'marcas-exclusivas': {
    slug: 'marcas-exclusivas',
    name: 'Marcas Exclusivas',
    title: 'Marcas Exclusivas Promocionales',
    h1: 'Productos de Marcas Premium',
    description: 'Productos de marcas premium para regalos corporativos exclusivos. Alta calidad y personalización.',
    shortDescription: 'Marcas premium y exclusivas',
    keywords: 'marcas exclusivas promocionales, regalos premium corporativos, merchandising exclusivo',
    icon: '⭐',
    featured: false
  },
  
  'master-line': {
    slug: 'master-line',
    name: 'Master Line',
    title: 'Línea Master Line',
    h1: 'Productos Master Line Premium',
    description: 'Productos Master Line de alta calidad. Artículos ejecutivos y premium con personalización elegante.',
    shortDescription: 'Línea ejecutiva Master Line',
    keywords: 'master line promocionales, productos premium, artículos ejecutivos personalizados',
    icon: '👔',
    featured: false
  },
  
  'medicos-farmaceuticos': {
    slug: 'medicos-farmaceuticos',
    name: 'Médicos y Farmacéuticos',
    title: 'Productos Médicos y Farmacéuticos Promocionales',
    h1: 'Artículos para el Sector Salud',
    description: 'Pastilleros, kits de primeros auxilios, termómetros y productos médicos personalizados para el sector salud.',
    shortDescription: 'Productos para sector salud',
    keywords: 'productos médicos promocionales, farmacéuticos personalizados, merchandising salud',
    icon: '⚕️',
    featured: false
  },
  
  'memorias-usb': {
    slug: 'memorias-usb',
    name: 'Memorias USB',
    title: 'Memorias USB Personalizadas',
    h1: 'USB Promocionales con Logo',
    description: 'USB promocionales de 8GB, 16GB, 32GB, 64GB. Diseños creativos: formas 2D/3D, giratorias, tarjeta. Grabado láser o impresión.',
    shortDescription: 'USB en múltiples diseños y capacidades',
    keywords: 'memorias usb personalizadas, usb con logo, pendrive promocional, usb corporativo',
    icon: '💾',
    featured: true
  },
  
  // MUGS, BOTELLAS, VASOS Y TERMOS
  'mugs-botellas-vasos-termos': {
    slug: 'mugs-botellas-vasos-termos',
    name: 'Mugs, Botellas, Vasos y Termos',
    title: 'Mugs, Botellas, Vasos y Termos Personalizados',
    h1: 'Drinkware Promocional',
    description: 'Drinkware promocional: mugs cerámicos, termos de acero, botellas deportivas, vasos térmicos con logo.',
    shortDescription: 'Mugs, termos y botellas',
    keywords: 'mugs personalizados, termos con logo, botellas promocionales, drinkware corporativo',
    icon: '☕',
    featured: true
  },
  
  'nuevos-productos-2023': {
    slug: 'nuevos-productos-2023',
    name: 'Nuevos Productos 2023',
    title: 'Nuevos Productos Promocionales 2023',
    h1: 'Novedades 2023',
    description: 'Últimas novedades en productos promocionales. Tendencias 2023 en merchandising y regalos corporativos.',
    shortDescription: 'Últimas novedades del catálogo',
    keywords: 'nuevos productos promocionales 2023, novedades merchandising, tendencias promocionales',
    icon: '🆕',
    featured: true
  },
  
  'oficina': {
    slug: 'oficina',
    name: 'Oficina',
    title: 'Artículos de Oficina Promocionales',
    h1: 'Productos de Oficina Personalizados',
    description: 'Libretas, agendas, organizadores, portadocumentos, accesorios de escritorio personalizados para la oficina.',
    shortDescription: 'Artículos y accesorios de oficina',
    keywords: 'artículos oficina promocionales, papelería corporativa, accesorios escritorio personalizados',
    icon: '📎',
    featured: true
  },
  
  'paraguas-impermeables': {
    slug: 'paraguas-impermeables',
    name: 'Paraguas e Impermeables',
    title: 'Paraguas e Impermeables Promocionales',
    h1: 'Paraguas Personalizados',
    description: 'Paraguas automáticos, manuales, de golf, impermeables y capas de lluvia con estampado de logo.',
    shortDescription: 'Paraguas e impermeables',
    keywords: 'paraguas personalizados, impermeables con logo, sombrillas promocionales',
    icon: '☂️',
    featured: false
  },
  
  'pharma-cuidado-personal': {
    slug: 'pharma-cuidado-personal',
    name: 'Pharma y Cuidado Personal',
    title: 'Pharma y Cuidado Personal',
    h1: 'Productos Pharma Promocionales',
    description: 'Productos farmacéuticos y de cuidado personal. Kits de higiene, productos wellness personalizados.',
    shortDescription: 'Pharma y wellness',
    keywords: 'pharma promocional, cuidado personal corporativo, productos wellness personalizados',
    icon: '💊',
    featured: false
  },
  
  'plastico-polilactico': {
    slug: 'plastico-polilactico',
    name: 'Plástico Poliláctico',
    title: 'Productos en Plástico Poliláctico',
    h1: 'Productos PLA Biodegradables',
    description: 'Artículos promocionales en PLA, plástico biodegradable derivado del maíz. Alternativa ecológica.',
    shortDescription: 'Productos en PLA biodegradable',
    keywords: 'plástico poliláctico, PLA promocional, productos biodegradables, merchandising ecológico',
    icon: '🌽',
    featured: false
  },
  
  'produccion-nacional': {
    slug: 'produccion-nacional',
    name: 'Producción Nacional',
    title: 'Producción Nacional Colombia',
    h1: 'Productos Hechos en Colombia',
    description: 'Productos promocionales fabricados 100% en Colombia. Apoya la industria nacional con tu merchandising.',
    shortDescription: 'Fabricación 100% colombiana',
    keywords: 'producción nacional promocionales, hecho en colombia, industria colombiana merchandising',
    icon: '🇨🇴',
    featured: true
  },
  
  'productos-futbol': {
    slug: 'productos-futbol',
    name: 'Productos Fútbol',
    title: 'Productos de Fútbol Promocionales',
    h1: 'Artículos de Fútbol Personalizados',
    description: 'Balones, uniformes, accesorios para hinchas, productos temáticos de fútbol personalizados.',
    shortDescription: 'Productos temáticos de fútbol',
    keywords: 'productos fútbol promocionales, balones personalizados, merchandising futbolero',
    icon: '⚽',
    featured: false
  },
  
  'relojes': {
    slug: 'relojes',
    name: 'Relojes',
    title: 'Relojes Promocionales',
    h1: 'Relojes Personalizados',
    description: 'Relojes de pared, escritorio y pulsera personalizados. Grabado láser en esfera o correa.',
    shortDescription: 'Relojes de pared y pulsera',
    keywords: 'relojes personalizados, relojes con logo, relojes promocionales, relojes corporativos',
    icon: '⌚',
    featured: false
  },
  
  // SANITIZER
  'sanitizer': {
    slug: 'sanitizer',
    name: 'Sanitizer',
    title: 'Productos Sanitizer y Bioseguridad',
    h1: 'Kits de Bioseguridad Personalizados',
    description: 'Gel antibacterial, dispensadores, kits de bioseguridad, atomizadores personalizados.',
    shortDescription: 'Productos de bioseguridad',
    keywords: 'sanitizer personalizado, gel antibacterial promocional, bioseguridad corporativa',
    icon: '🧴',
    featured: false
  },
  
  'tecnologia': {
    slug: 'tecnologia',
    name: 'Tecnología',
    title: 'Productos Tecnológicos Promocionales',
    h1: 'Gadgets y Tecnología Personalizados',
    description: 'USB, power banks, parlantes bluetooth, audífonos, accesorios tech personalizados con tu logo.',
    shortDescription: 'Gadgets y accesorios tecnológicos',
    keywords: 'tecnología promocional, gadgets corporativos, accesorios tech personalizados',
    icon: '💻',
    featured: true
  },
  
  'variedades': {
    slug: 'variedades',
    name: 'Variedades',
    title: 'Variedades Promocionales',
    h1: 'Productos Varios',
    description: 'Amplia variedad de productos promocionales para todas las necesidades y presupuestos.',
    shortDescription: 'Productos variados',
    keywords: 'variedades promocionales, productos diversos, merchandising variado',
    icon: '🎁',
    featured: true
  }
};

/**
 * Gets the SEO information of a category by its slug
 * @param {string} categorySlug - The category's slug
 * @param {string} subcategorySlug - The subcategory's slug (optional)
 * @returns {Object} SEO information of the category
 */
export const getCategorySeoInfo = (categorySlug, subcategorySlug = null) => {
  const key = subcategorySlug || categorySlug;
  return CATEGORY_SEO_MAP[key] || {
    slug: key,
    name: key.replace(/-/g, ' ').charAt(0).toUpperCase() + key.slice(1).replace(/-/g, ' '),
    title: `${key.replace(/-/g, ' ').charAt(0).toUpperCase() + key.slice(1).replace(/-/g, ' ')} Promocionales`,
    description: `Productos promocionales de la categoría ${key.replace(/-/g, ' ')}. Personalización con logo corporativo.`,
    keywords: `${key.replace(/-/g, ' ')} promocionales, ${key.replace(/-/g, ' ')} personalizados`,
    icon: '📦',
    featured: false
  };
};

/**
 * Gets all featured categories
 * @returns {Array} Array of featured categories
 */
export const getFeaturedCategories = () => {
  return Object.values(CATEGORY_SEO_MAP).filter(category => category.featured);
};

/**
 * Gets all categories sorted alphabetically
 * @returns {Array} Array of all sorted categories
 */
export const getAllCategoriesSorted = () => {
  return Object.values(CATEGORY_SEO_MAP).sort((a, b) => a.name.localeCompare(b.name));
};

/**
 * Generates the breadcrumb for a category.
 * @param {string} categorySlug - The slug of the category
 * @ @param {string} subcategorySlug - The slug of the subcategory (optional)
 * @returns {Array} Array of breadcrumb items
 */
export const generateCategoryBreadcrumbs = (categorySlug, subcategorySlug = null) => {
  const breadcrumbs = [
    { name: 'Inicio', url: '/' },
    { name: 'Categorías', url: '/categorias' }
  ];
  
  if (subcategorySlug) {
    const parentCategory = getCategorySeoInfo(categorySlug);
    breadcrumbs.push(
      { name: parentCategory.name, url: `/categorias/${categorySlug}` },
      { name: getCategorySeoInfo(subcategorySlug).name, url: `/categorias/${categorySlug}/${subcategorySlug}` }
    );
  } else {
    breadcrumbs.push(
      { name: getCategorySeoInfo(categorySlug).name, url: `/categorias/${categorySlug}` }
    );
  }
  
  return breadcrumbs;
};

/**
 * Search categories by term
 * @param {string} searchTerm - Search term
 * @returns {Array} Array of matching categories
 */
export const searchCategories = (searchTerm) => {
  const term = searchTerm.toLowerCase();
  return Object.values(CATEGORY_SEO_MAP).filter(category => 
    category.name.toLowerCase().includes(term) ||
    category.keywords.toLowerCase().includes(term) ||
    category.description.toLowerCase().includes(term)
  );
};